import { appConfig } from 'brand-config';

/**
 * Executive management report link (#35090). The per-brand app config carries a
 * `reports.url` (e.g. Forreston's Vantage management report). Brands that haven't
 * turned the feature on leave `reports` unset, so no menu item renders for them —
 * CFM and the other mutuals can opt in later by adding their own `reports.url`.
 * Access is separately gated on the internal-only `CanViewReports` permission.
 */
export const resolveReportsUrl = (reports) => reports?.url ?? null;

export const getReportsUrl = () => resolveReportsUrl(appConfig?.reports);

export const isReportsEnabled = () => Boolean(getReportsUrl());
